module.exports = __webpack_public_path__ + "img/cert1.86c71b95.png";